import Vue from 'vue'
import VueRouter from 'vue-router'
import Logis from '../views/Logis.vue'
import Chateau from '../views/Chateau.vue'
import Choose from '../views/Choose.vue'
import Gaillon from '../views/Gaillon.vue'
import Marche from '../views/Marche.vue'
import Musee from '../views/Musee.vue'
import Restaurants from '../views/Restaurants.vue'
import Admin from '../views/Admin.vue'
import Login from '../views/Login.vue'
import Appartement_1 from '../views/Appartement_1.vue'
import Contact from '../views/Contact.vue'
import Sidebar from '../components/Sidebar.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'home',
    components : {
      main : Choose,
    }
  },
  {
    path : '/logisdesclos',
    name : 'logis',
    components : {
      main : Logis
    }
  },
  {
    path : '/Contact',
    name : 'contact',
    components : {
      main : Contact
    }
  },
  {
    path : '/Appartement-1',
    name : 'appartement-1',
    components : {
      main : Appartement_1,
    }
  },
  {
    path : '/logisduchateau',
    name : 'logischateau',
    components : {
      main : Chateau
    }
  },
  {
    path : '/Admin',
    name : 'admin',
    components : {
      main : Admin
    }
  },
  {
    path : '/Login',
    name : 'login',
    components : {
      main : Login
    }
  },
  {
    path : '/:appartement/Marche',
    name : 'marche',
    components : {
      main : Marche
    }
  },
  {
    path : '/:appartement/Restaurants',
    name : 'restaurants',
    components : {
      main : Restaurants
    }
  },
  {
    path : '/:appartement/Musées',
    name : 'musee',
    components : {
      main : Musee
    }
  },
  {
    path : '/:appartement/gaillon',
    name : 'gaillon',
    components : {
      main : Gaillon
    }
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    components: {
      main : () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
